export default "__VITE_ASSET__DdaVGiBT__"